import { PELICAN_COPY_TRADE_PROVIDER } from '@aqx-core/common/constants/copy-trade';
import mixpanel from '@aqx-core/common/mixpanel';
import { authenticationService } from '@aqx-core/common/services/auth';
import { companyService } from '@aqx-core/common/services/company';
import { EMixpanelProperties } from '@aqx-core/common/services/mixpanel/types';

import { eventNameHelper, userHelper } from '../helpers';
import { IMixpanelCopyTradeInterestProps } from './types';

class CopyTradeAnalysisService {
  public copyTradeInterest = ({ action }: IMixpanelCopyTradeInterestProps) => {
    const userAccountProperties = userHelper.createUserAccountProperties();
    const eventName = eventNameHelper.mapCopyTradeInterestEventName(action);
    const companyIntegration = companyService.getCompanyIntegration();
    const tenantId = companyService.getCompanyTenantId();

    const { selectedTradingAccountDetails } = authenticationService.context;
    const { accountType } = selectedTradingAccountDetails || {};

    mixpanel.track(eventName, {
      ...userAccountProperties,
      [EMixpanelProperties.PROVIDER]: PELICAN_COPY_TRADE_PROVIDER,
      [EMixpanelProperties.SOURCE]: authenticationService.context.source,
      [EMixpanelProperties.TENANT_ID]: tenantId,
      [EMixpanelProperties.MAIN_PRODUCT_CODE]: companyIntegration,
      [EMixpanelProperties.USER_ACCOUNT_TYPE]: accountType
    });
  };
}

const copyTradeAnalysisService = new CopyTradeAnalysisService();
export default copyTradeAnalysisService;
